module.exports = "<ul>\n  <li ng-repeat=\"item in $ctrl.itemList\">\n    <adp-chart-legend-item item=\"item\"></adp-chart-legend-item>\n  </li>\n</ul>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpChartLegend/adpChartLegend.html
// module id = 621
// module chunks = 0